import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getTenantMarketingDefaults,
  updateTenantMarketingDefaults,
} from "../api";
import { useNotification } from "contexts/NotificationContext";

export const useGetTenantMarketingDefaults = () => {
  const { data, isLoading, isError, error, isSuccess } = useQuery({
    queryKey: ["tenant-marketing-defaults"],
    queryFn: () => getTenantMarketingDefaults(),
  });

  return { data, isLoading, isSuccess, isError, error };
};

export const useUpdateTenantMarketingDefaults = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: (data) => updateTenantMarketingDefaults(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["tenant-marketing-defaults"],
      });
      showNotification("success", "Internet marketing defaults updated successfully!");
    },
    onError: (error) => {
      console.error("Error updating tenant marketing defaults:", error);
      let errorMessage =
        "Error updating internet marketing defaults. Please try again.";
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      showNotification("danger", errorMessage);
    },
  });
};
